import React from 'react';
import { motion } from 'framer-motion';

/**
 * AppTableCard — Animated card wrapper for tables.
 *
 * Provides the white-card + scroll shell with optional framer-motion entrance.
 * Accepts `footer` (e.g. pagination) and passes `children` as table content.
 *
 * @param {boolean}  [animated=true]   — enable/disable motion entrance
 * @param {number}   [delay=0]         — motion delay in seconds
 * @param {string}   [className]       — extra classes on the outer card
 * @param {React.ReactNode} [footer]   — rendered after the scroll area (pagination, etc.)
 * @param {React.ReactNode} children   — table (or anything) inside the scroll wrapper
 */
const AppTableCard = ({
    animated = true,
    delay = 0,
    className = '',
    footer,
    children,
    ...rest
}) => {
    const motionProps = animated
        ? {
              initial: { opacity: 0, y: 12 },
              animate: { opacity: 1, y: 0 },
              transition: { delay, type: 'spring', stiffness: 260, damping: 22 },
          }
        : {};

    const Tag = animated ? motion.div : 'div';

    return (
        <Tag className={`tk-table-card ${className}`} {...motionProps} {...rest}>
            <div className="tk-table-scroll">
                {children}
            </div>
            {footer}
        </Tag>
    );
};

export default AppTableCard;
